import { Eyebrow, ArrowLink } from "./motion";
import { brands, partners } from "../../data/content";

const partnerLogos = partners.map((p) => ({ name: p.name, logo: p.logoColor }));
const clientLogos = brands.map((b) => ({ name: b.name, logo: b.logo }));
const allLogos = [...partnerLogos, ...clientLogos];

export default function PartnersStrip() {
  return (
    <section className="bg-mist px-6 py-20 lg:px-12 lg:py-28" aria-label="Our partners">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div className="max-w-2xl">
          <Eyebrow>Our Partners</Eyebrow>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
            We take our clients as partners — proven global leaders and South Africa's best brands.
          </h2>
        </div>
        <ArrowLink to="/partnerships" testId="partners-see-all">
          Explore Partnerships
        </ArrowLink>
      </div>

      <div
        className="mt-16 grid grid-cols-2 gap-px border border-ink/10 bg-ink/10 sm:grid-cols-4 lg:grid-cols-8"
        data-testid="partner-grid"
      >
        {allLogos.map((p) => (
          <div
            key={p.name}
            className="group flex h-32 items-center justify-center bg-white px-6 transition-colors duration-300 hover:bg-mist md:h-36"
          >
            <img
              src={p.logo}
              alt={p.name}
              loading="lazy"
              data-testid={`partner-logo-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="h-9 w-auto object-contain lg:h-11"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
